<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" />
    <dv-decoration-5 class="header-center-decoration" />
    <dv-decoration-8 class="header-right-decoration" :reverse="true" />
    <div class="center-title">丛台区消费券活动(二期)</div>
    <div class="datediv box box_i_center">
      <span class="iconfont icon-time"></span>
      <span>{{thisdate}}</span>
    </div>
  </div>
</template>

<script>
    import miment from 'miment';
    export default {
      name: "topHeader",
      data() {
        return {
          thisdate: miment().format('YYYY-MM-DD hh:mm:ss')
        }
      },
      created() {
        this.t = setInterval(()=> {
          this.thisdate = miment().format('YYYY-MM-DD hh:mm:ss')
        },1000)
      },
      destroyed() {
        if(this.t) {
          clearInterval(this.t)
          this.t = null
        }
      }
    }
</script>
<style lang="less">
  #top-header {
    position: relative;
    width: 100%;
    height: 110px;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
    .header-center-decoration {
      width: 40%;
      height: 50px;
      margin-top: 80px;
    }
    .header-left-decoration, .header-right-decoration {
      width: 25%;
      height: 40px;
    }
    .datediv {
      position: absolute;
      bottom: 10px;
      right: 150px;
      font-size: 30px;
      z-index: 10;
      .iconfont {
        font-size: 25px;
        padding-right: 15px;
      }
    }
    .center-title {
      position: absolute;
      font-size: 35px;
      font-weight: bold;
      left: 50%;
      top: 15px;
      transform: translateX(-50%);
    }
  }
</style>
<style scoped>

</style>
